export const MAX_WIDTH_SMALL_LOGIN = 767;
export const MAX_WIDTH_SMALL_SCREEN = 500;
export const DEFAULT_REDIRECT_ROUTE = '/home';
export const HOMEPAGE_REDIRECT_ROUTE = 'https://dealmakers24.com';
export const COPY_MESSAGE = 'Copied to clipboard';
export const BASE_URL = process.env.REACT_APP_BASE_URL? process.env.REACT_APP_BASE_URL : 'https://stage.api.raze.co.in';
export const BASE_URL_PARSER = 'https://parser.raze.co.in/api';
export const CATALOGUES_REDIRECT_ROUTE = 'https://catalogues.raze.co.in';
export const BASE_IMG = 'https://dg53pzd6emty4.cloudfront.net/business'
export const MAX_FIELD_PER_ROW = 4;

export const AUTHS_ALLOWED = ['google', 'local'];
export const NAV_LOGO_IMG = `${BASE_IMG}/deals.svg`;
export const NAV_TITLE_IMG = `${BASE_IMG}/deals_text.png`;

export const LOGIN_LOGO_IMG = `${BASE_IMG}/deals_logo.svg`;
export const LOGIN_TITLE_IMG = '';

export const BRAND_NAME = 'Dealmakers24';
export const BRAND_TAGLINE = 'Connecting Corporate Buyers with Trusted Sellers';

export const NAVBAR_ITEMS = [
    { label: 'About Us', route: '/about', className: 'Link hover1', liClassName: '' },
    { label: 'FAQs', route: '/faqs', className: 'Link hover1', liClassName: '' },
    { label: 'Careers', route: '/careers', className: 'Link hover1', liClassName: '' },
    { label: 'Contact Us', route: '/contact', showWhenSettings: false, className: 'Link color_contact', liClassName: 'color_contact' },
  ];

export const NAVBAR_ITEMS_RAZE = [
    { label: 'Products', route: '/products', className: 'Link hover1', liClassName: '' },
    { label: 'Pricing', route: '/pricing', className: 'Link hover1', liClassName: '' },
    { label: 'Team', route: '/team', className: 'Link hover1', liClassName: '' },
    { label: 'Blogs', route: '/blogs', className: 'Link hover1', liClassName: '' },
    { label: 'Schedule a demo', route: '#contact?scroll=scroll-top', onClick: 'scroll-top', showWhenSettings: false, className: 'Link color_contact', liClassName: 'color_contact' },
  ];

export const COMPONENT_ROUTE_MAP = {
    DashboardOverall: 'dashboard-overall',
    VendorOnboard: 'vendor-add',
    LeadOnboard: 'lead-add',
    VendorLists: 'vendor-list',
    LeadLists: 'lead-list',
    VendorProfile: 'vendor-profile',
    LeadProfile: 'lead-profile',
    VendorRank: 'vendor-rank',
    VendorDiscover: 'vendor-discover',
    VendorExplore: 'vendor-explore',
    AccountInfo: 'account-info',
    VendorSubscriptionPlans: 'subscription-vendor',
    VendorQuotations: 'quotations',
    Vendors: 'vendors',
    VendorApprovals: 'vendor-approvals',
    VendorTasks: 'vendor-tasks',
    EnterpriseData: 'enterprise-data',
    ProductListing: 'product-discover',
    CategoriesExplore: 'categories-explore',
    LocalitiesExplore: 'localities-explore'
}
export const PROFILE_CTA_MAP = {
    VERIFIED_VENDOR: 'Vendor has completed the verification process, all the following info is marked as correct',
    NOT_VERIFIED_VENDOR: "Verification is pending from Vendor's end"
}
export const ACCOUNT_CTA_MAP = {
    ACCOUNT_VERIFICATION: 'Important: Some account information has been sourced in advance from different partners, please verify and make rectifications wherever required',
}

export const ERROR_CTA_MAP = {
    FILE_UPLOAD_ERROR: 'File upload failed. Please try again.',
    FILE_TYPE_ERROR: 'This file type is not supported.'
}
export const COMPONENT_DISPLAY_TEXT = {
    PROFILE_BREADCRUMB: 'Vendor Profile',
    LEAD_PROFILE_BREADCRUMB: 'Lead Profile',
}
export const ONBOARDING_COMPLETED_STATUS = 'onboarding-completed'
export const CREATION_COMPLETED_STATUS   = 'creation-completed'

export const LINK_URL_NOTES             = 'notes-vendor'
export const LINK_URL_PAYWALL           = 'pricing-enterprise'
export const LINK_URL_QUOTES            = 'quotes-vendor'

export const QUOTATION_TABLE_TYPE = {
  VIEW: 'viewData',
  EDIT: 'editData',
};

export const QUOTATION_MODAL_TYPE = {
  LIST_APPROVALS: 'ListApprovals',
};

export const QUOTATION_BUYER_ITEM_ACTIONS = {
  ACCEPT: 'accept',
  NEGOTIATE: 'negotiate',
  REJECT: 'reject',
};

export const LINK_TYPE_MODAL            = 'modal'
export const LINK_EDIT_DETAILS          = 'edit-details'
export const LINK_ATTACHMENTS           = 'attachment-vendor'
export const LINK_EMAIL_VERIFICATION    = 'verify-vendor'
export const LINK_URL_VENDOR_PROFILE    = 'vendor-profile'
export const LINK_TYPE_ROUTE_INTERNAL   = 'internal'
export const LINK_API_CALL              = 'api'

export const MODAL_TITLES = {
    note: {
        ADD: 'Add a note',
        EDIT: 'Edit a note',
        DELETE: 'Delete a note'
    }
}

export const SPIN_TEXT_MAP = {
    PRODUCT_IN_BASKET: 'Added to basket',
    PRODUCT_NOTIN_BASKET: 'Removed from basket',
    VENDOR_RESGISTRATION_SUCCESS: 'Vendor successfully added',
    VENDOR_RESGISTRATION_ERROR: 'Something went wrong, Please try again'
}

export const LINK_SEPERATOR = '\n Link:- \n';
/* eslint-disable no-useless-escape */
export const LINK_REGEX = /((?:(?:https?|ftp):\/\/|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s]*)?)/gi;

export const FILTER_OPTIONS = {
    column: [
        { value: 'sinkPartnerName', label: 'Name' },
        { value: 'category', label: 'Category' },
        { value: 'status', label: 'Status' },
        { value: 'state', label: 'State' },
        { value: 'universal_id', label: 'Application ID' }
    ],
    operator: [
        { value: 'eq', label: '=' },
        { value: 'neq', label: '!=' },
        { value: 'in', label: 'in' },
        { value: 'nin', label: 'not in' },
    ],
    category: [],
    entityType: [],
    status: [
        { value: 'started', label: 'Started' },
        { value: 'pending', label: 'Pending' },
        { value: 'completed', label: 'Completed' },
    ],
    state: [
        { value: 'creation', label: 'Creation' },
        { value: 'invitation', label: 'Invitation' },
        { value: 'verification', label: 'Verification' },
        { value: 'onboarding', label: 'Onboarding' },
    ],
};

export const QUOTE_STATUS_FILTER_OPTIONS = [
    { value: 'draft', label: 'Draft' },
    { value: 'ready', label: 'Ready' },
    { value: 'pending', label: 'Pending' },
    { value: 'active', label: 'Active' },
    { value: 'inactive', label: 'InActive' },
    { value: 'completed', label: 'Completed' },
];

export const FEED_FILTER_OPTIONS = {
    "product": {
        level1: "Segment",
        filters: ['likeness', 'theme'],
        likeness:{
            cta: 'Likeness',
            mode: 'multiple',
            placeholder: 'Set Preference',
            options: [
                {label: 'Trending', value: 'trending'},
                {label: 'Most Liked', value: 'most-liked'},
                {label: 'Distinctive', value: 'distinctive'},
                {label: 'Top in Category', value: 'top-category'},
            ],
            value: 'selectedRating',
            callback: 'onRatingChange'
        },
        theme:{
            cta: 'Theme',
            mode: '',
            placeholder: 'Set Value',
            options: [
                { value: "sustainable", label: "Sustainable" },
                { value: "eco_friendly", label: "Eco-Friendly" },
                { value: "social_impact", label: "Social Impact" },
                { value: "green_energy", label: "Green Energy" },
                { value: "zero_waste", label: "Zero-Waste" },
                { value: "organic", label: "Organic" },
                { value: "natural", label: "Natural" },
                { value: "women_led", label: "Women Led" },
            ],
            value: '',
            callback: ''
        },
    },
    "vendor": {
        level1: "Category",
        filters: ['city', 'likeness', 'rating'],
        category: {
            cta: 'Category',
            value: 'categories',
            callback: 'onCategoryChange'
        },
        city:{
            cta: 'City',
            mode: 'multiple',
            placeholder: 'Set Location',
            options: [
                {label: 'Mumbai', value: 'mumbai'},
                {label: 'Delhi', value: 'delhi'},
                {label: 'Bangalore', value: 'bangalore'},
                {label: 'Hyderabad', value: 'hyderabad'},
                {label: 'Chennai', value: 'chennai'},
                {label: 'Kolkata', value: 'kolkata'},
                {label: 'Pune', value: 'pune'},
            ],
            value: 'selectedCity',
            callback: 'onCityChange'
        },
        likeness:{
            cta: 'Likeness ',
            mode: 'multiple',
            placeholder: 'Set Preference',
            options: [
                {label: 'Verified', value: 'verified'},
                {label: 'Trending', value: 'trending'},
                {label: 'Most Liked', value: 'most-liked'},
                {label: 'Top in Category', value: 'top-category'},
            ],
            value: 'selectedRating',
            callback: 'onRatingChange'
        },
        rating:{
            cta: 'Ratings',
            mode: 'multiple',
            placeholder: 'Set Boundary',
            options: [
                {label: '1 Star', value: '1'},
                {label: '2 Star', value: '2'},
                {label: '3 Star', value: '3'},
                {label: '4 Star', value: '4'},
                {label: '5 Star', value: '5'},
            ],
            value: 'selectedRating',
            callback: 'onRatingChange'
        }
    },
    "service": {
        level1: "Category",
        filters: ['segment', 'city', 'likeness'],
        category: {
            cta: 'Category',
            value: 'categories',
            callback: 'onCategoryChange'
        },
        city:{
            cta: 'City',
            mode: '',
            placeholder: 'Set Location',
            options: [
                {label: 'Mumbai', value: 'mumbai'},
                {label: 'Delhi', value: 'delhi'},
                {label: 'Bangalore', value: 'bangalore'},
                {label: 'Hyderabad', value: 'hyderabad'},
                {label: 'Chennai', value: 'chennai'},
                {label: 'Kolkata', value: 'kolkata'},
                {label: 'Pune', value: 'pune'},
            ],
            value: 'selectedCity',
            callback: 'onCityChange'
        },
        likeness:{
            cta: 'Likeness ',
            mode: '',
            placeholder: 'Set Preference',
            options: [
                {label: 'Verified', value: 'verified'},
                {label: 'Trending', value: 'trending'},
                {label: 'Most Liked', value: 'most-liked'},
                {label: 'Top in Category', value: 'top-category'},
            ],
            value: 'selectedRating',
            callback: 'onRatingChange'
        },
        segment:{
            cta: 'Segment',
            mode: 'multiple',
            placeholder: 'Set Budget',
            options: [
                {label: 'Super Premium', value: 'Super Premium'},
                {label: 'Premium', value: 'Premium'},
                {label: 'Value For Money', value: 'Value for money'},
                {label: 'Economical', value: 'Economical'}
            ],
            value: 'selectedSegment',
            callback: 'onSegmentChange'
        }
    },
    "operation": {
        level1: "Category",
        filters: ['segment', 'likeness'],
        category: {
            cta: 'Category',
            value: 'categories',
            callback: 'onCategoryChange'
        },
        likeness:{
            cta: 'Rating ',
            mode: '',
            placeholder: 'Set Preference',
            options: [
                {label: 'Verified', value: 'verified'},
                {label: 'Trending', value: 'trending'},
                {label: 'Most Liked', value: 'most-liked'},
                {label: 'Top in Category', value: 'top-category'},
            ],
            value: 'selectedRating',
            callback: 'onRatingChange'
        },
        segment:{
            cta: 'Segment',
            mode: 'multiple',
            placeholder: 'Set Budget',
            options: [
                {label: 'Super Premium', value: 'Super Premium'},
                {label: 'Premium', value: 'Premium'},
                {label: 'Value For Money', value: 'Value for money'},
                {label: 'Economical', value: 'Economical'}
            ],
            value: 'selectedSegment',
            callback: 'onSegmentChange'
        }
    }
}

export const DEFAULT_TAB = "1"
export const TAB_CONFIG_MAP = {
    "1": {
        actionedBy: 'approver',
        approvalType: 'ListApprovals',
        filterBy: 'finalStatus-in-pending'
    },
    "2": {
        actionedBy: 'requester',
        approvalType: 'ListApprovalsAdmin',
        filterBy: ''
    },
    "3": {
        actionedBy: 'approver',
        approvalType: 'ListApprovals',
        filterBy: 'finalStatus-in-rejected,approved'
    }
}

// Category Map - Single source of truth for categories and subcategories
export const CATEGORY_MAP = {
    automobile: {
        value: 'automobile',
        label: 'Automobile & Transportation',
        subCategories: [
            { value: 'two_wheeler_dealer', label: "Two-Wheeler Dealer" },
            { value: 'two_wheeler_spares_accessories', label: "Two-Wheeler Spares & Accessories" },
            { value: 'four_wheeler_dealer', label: "Four-Wheeler Dealer" },
            { value: 'car_accessories', label: "Car Accessories" },
            { value: 'heavy_automobile_spares', label: "Heavy Automobile Spares" },
            { value: 'heavy_commercial_vehicles', label: "Heavy Commercial Vehicles" },
            { value: 'light_automobile_spares', label: "Light Automobile Spares" },
            { value: 'light_commercial_vehicles', label: "Light Commercial Vehicles" },
            { value: 'tyres', label: "Tyres" },
            { value: 'vehicle_rentals', label: "Vehicle Rentals" }
        ]
    },
    construction: {
        value: 'construction',
        label: 'Construction & Building Materials',
        subCategories: [
            { value: 'aluminium_door_n_windows', label: "Aluminium Door N Windows" },
            { value: 'bricks', label: "Bricks" },
            { value: 'false_ceiling', label: "False Ceiling" },
            { value: 'glass', label: "Glass" },
            { value: 'paver_tiles', label: "Paver Tiles" },
            { value: 'plywood_and_laminates', label: "Plywood and Laminates" },
            { value: 'rod_and_cement', label: "Rod and Cement" },
            { value: 'roofing_sheets', label: "Roofing Sheets" },
            { value: 'tiles_marbles', label: "Tiles & Marbles" },
            { value: 'upvc_door_n_windows', label: "UPVC Door N Windows" }
        ]
    },
    agriculture: {
        value: 'agriculture',
        label: 'Agriculture & Farming',
        subCategories: [
            { value: 'agro_chemicals_and_pesticides', label: "Agro Chemicals and Pesticides" },
            { value: 'agriculture_services', label: "Agriculture Services" }
        ]
    },
    food_and_beverages: {
        value: 'food_and_beverages',
        label: 'Food & Beverages',
        subCategories: [
            { value: 'bakery', label: "Bakery" },
            { value: 'dairy_products', label: "Dairy Products" },
            { value: 'drinking_water_supplier', label: "Drinking Water Supplier" },
            { value: 'dry_fruits_and_organic_food', label: "Dry Fruits and Organic Food" },
            { value: 'grocery', label: "Grocery" },
            { value: 'snacks_and_sweets', label: "Snacks and Sweets" },
            { value: 'vegetables_fruits', label: "Vegetables & Fruits" }
        ]
    },
    electronics: {
        value: 'electronics',
        label: 'Electronics & Technology',
        subCategories: [
            { value: 'computer_hardware_software', label: "Computer Hardware & Software" },
            { value: 'electricals', label: "Electricals" },
            { value: 'inverter_and_battery', label: "Inverter and Battery" },
            { value: 'mobiles', label: "Mobiles" }
        ]
    },
    furnitures: {
        value: 'furnitures',
        label: 'Home & Furniture',
        subCategories: [
            { value: 'furniture', label: "Furniture" },
            { value: 'home_appliances', label: "Home Appliances" },
            { value: 'kitchenware_utensils', label: "Kitchenware Utensils" },
            { value: 'mattress_foam', label: "Mattress & Foam" },
            { value: 'lock_door_furniture_fittings', label: "Lock, Door & Furniture Fittings" }
        ]
    },
    healthcare: {
        value: 'healthcare',
        label: 'Healthcare & Medical',
        subCategories: [
            { value: 'medicine', label: "Medicine" },
            { value: 'optical', label: "Optical" },
            { value: 'surgical_equipments', label: "Surgical Equipment's" }
        ]
    },
    services: {
        value: 'services',
        label: 'Professional Services',
        subCategories: [
            { value: 'advertising_agency', label: "Advertising Agency" },
            { value: 'caterers_catering_services', label: "Caterers / Catering Services" },
            { value: 'digital_marketing_graphics_design', label: "Digital Marketing & Graphics Design" },
            { value: 'events', label: "Events" },
            { value: 'life_insurance', label: "General, Health & Life Insurance" },
            { value: 'interior_designer', label: "Interior Designer" },
            { value: 'landscaping', label: "Landscaping" },
            { value: 'manpower_and_placement_services', label: "Manpower and Placement Services" },
            { value: 'printing_press', label: "Printing Press" },
            { value: 'security_services', label: "Security Services" },
            { value: 'tour_n_travels', label: "Tour N Travels" },
            { value: 'vaastu_consultant', label: "Vaastu Consultant" }
        ]
    },
    industrial_supplies: {
        value: 'industrial_supplies',
        label: 'Industrial & Manufacturing',
        subCategories: [
            { value: 'earthmoving_machinery_rentals', label: "Earthmoving Machinery Rentals" },
            { value: 'earthmoving_machinery_sales', label: "Earthmoving Machinery Sales" },
            { value: 'decorative_steel_fabricators', label: "Decorative Steel Fabricators" },
            { value: 'refrigeration_and_air_conditioning', label: "Refrigeration and Air Conditioning" },
            { value: 'rolling_shutters', label: "Rolling Shutters" },
            { value: 'structural_fabricators', label: "Structural Fabricators" },
            { value: 'water_pumps', label: "Water Pumps" }
        ]
    },
    retail: {
        value: 'retail',
        label: 'Retail & Lifestyle',
        subCategories: [
            { value: 'bicycles', label: "Bicycles" },
            { value: 'corporate_gifting', label: "Corporate Gifting" },
            { value: 'fitness_products', label: "Fitness Products" },
            { value: 'footwear', label: "Footwear" },
            { value: 'gift_items', label: "Gift Items" },
            { value: 'musical_equipments', label: "Musical Equipment's" },
            { value: 'pet_sales_and_grooming', label: "Pet Sales and Grooming" },
            { value: 'sports_equipment_and_trophies', label: "Sports Equipment and Trophies" },
            { value: 'staff_uniform', label: "Staff Uniform" },
            { value: 'stationery', label: "Stationery" }
        ]
    },
    plumbing: {
        value: 'plumbing',
        label: 'Plumbing & Sanitary',
        subCategories: [
            { value: 'plumbing_sanitary_pipes', label: "Plumbing & Sanitary Pipes" },
            { value: 'sanitary_plumbing_pipes', label: "Sanitary & Plumbing Pipes" }
        ]
    },
    safety: {
        value: 'safety',
        label: 'Safety & Security',
        subCategories: [
            { value: 'cctv_security_solutions', label: "CCTV & Security Solutions" },
            { value: 'fire_fighting_equipments', label: "Fire Fighting Equipment's" }
        ]
    },
    hospitality: {
        value: 'hospitality',
        label: 'Hospitality & General Supplies',
        subCategories: [
            { value: 'hardware_general_order_supplier', label: "Hardware & General Order Supplier" },
            { value: 'hotel_supplies', label: "Hotel Supplies" },
            { value: 'paints', label: "Paints" },
            { value: 'plastic_liners', label: "Plastic Liners" },
            { value: 'trunkey_fit_out_project', label: "Trunkey Fit-out Project" }
        ]
    },
    energy_solutions: {
        value: 'energy_solutions',
        label: 'Energy Solutions',
        subCategories: [
            { value: 'generator_rentals', label: "Generator Rentals" },
            { value: 'power_generator', label: "Power Generator" },
            { value: 'solar_products', label: "Solar Products" }
        ]
    }
};

// Super categories as array for Select options
export const SUPER_CATEGORY_LIST = Object.values(CATEGORY_MAP).map(({ value, label }) => ({ value, label }));

// Helper function to get subcategories for a super category
export const getSubCategoriesForSuperCategory = (superCategory) => {
    if (!superCategory || !CATEGORY_MAP[superCategory]) return [];
    return CATEGORY_MAP[superCategory].subCategories;
};